import { GetImages } from "../../utils/GetImages";
import "./tenantStyles.css";
import CustomInputs from "../common/Inputs";
import { useError } from "../../utils/context/ErrorContext";

const EditCustomComponent = ({
  label,
  placeholder,
  value,
  name,
  onChangeFunction,
  onBlurFunction,
  errorMessages = "",
  isError = false,
  isPasswordField = false,
  width =undefined,
  borderRadius = "8px",
  type = "text",
  linkWebsite = false,
  disabled = false,
  maxLength = undefined,
  required = false,
  isFormControl=false,
  currencySymbol="$",
  myClassName="",
  height=undefined
}) => {
  const { setErrors, setErrorMessages } = useError();

  const goToWebsiteHandler = () => {
    window.open("https://" + value, "_blank");
  };

  const handleBlur = (e) => {
    onBlurFunction(e);
  };

  return (
    <div
      style={{
        width: width,
        borderRadius: borderRadius,
      }}
      className="customEditTenantInputContainerStyles"
    >
      <div className="editInputContainer">
        <CustomInputs
          labelText={label}
          name={name}
          value={value}
          onChange={onChangeFunction}
          onBlur={handleBlur}
          placeholder={placeholder}
          isError={isError}
          disabled={disabled}
          isFormControl={isFormControl}
          myClassName={myClassName}
          type={isPasswordField ? "password" : type}
          maxLength={maxLength}
          required={required}
          height={height}
          width={width}

         currencySymbol={currencySymbol}
        />

        {linkWebsite && value.length > 0 && (
          <span
            onClick={goToWebsiteHandler}
            className="showPasswordIcon"
            style={{
              backgroundImage: `url(${GetImages.goToWebsiteIcon})`,
              top: "52%",
            }}
          />
        )}
      </div>
      {isError && (
        <p className="errorMessage">{errorMessages}</p>
      )}
    </div>
  );
};

export default EditCustomComponent;
